export class AddressValues {
  Email : string
	Name  : string
}

export class Email{
	From            : AddressValues
	ReplyTo         : AddressValues
	To              : AddressValues[]
	CC              : AddressValues[]
	BCC             : AddressValues[]
	Subject         : string
	Body            : string
	Type            : string
	RelatedObjectId : string
	AttachmentFiles : Array<string>

	constructor() {
		this.From            = new AddressValues()
		this.ReplyTo         = new AddressValues()
		this.To              = []
		this.CC              = []
		this.BCC             = []
		this.AttachmentFiles = []
		this.RelatedObjectId = ''
	}
}
